import { Observable, Subject, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { AuthenticationService } from '../security/authentication.service';
import { EnvironmentService } from '../environment.service';

interface TokenPayload {
  sub?: string;
  permissions?: string[];
}

@Injectable()
export class AuthorizationService {
  constructor(private authenticationService: AuthenticationService, private environmentService: EnvironmentService) {}

  isLotEditMode = new Subject<boolean>();
  currentUserMail = '';

  getPermissions(): Observable<string[]> {
    const token = this.authenticationService.getAccessToken();
    if (!token) {
      this.currentUserMail = '';
      return of([]);
    }
    const payload = this.decodeTokenPayload(token);
    this.currentUserMail = payload?.sub ?? '';
    const allPermissions = payload?.permissions ?? [];
    const appPrefix = this.environmentService.application + '.';
    const permissions = allPermissions.filter((p) => p.startsWith(appPrefix)).map((p) => p.substring(appPrefix.length));
    return of(permissions);
  }

  private decodeTokenPayload(token: string): TokenPayload | null {
    try {
      const parts = token.split('.');
      if (parts.length !== 3) {
        return null;
      }
      const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
      return JSON.parse(atob(base64)) as TokenPayload;
    } catch {
      return null;
    }
  }

  hasPermission(permission: string): Observable<boolean> {
    return this.getPermissions().pipe(map((p) => p.includes(permission)));
  }

  hasPermissions(permissions: string[]): Observable<boolean> {
    return this.getPermissions().pipe(map((p) => p.some((permission) => permissions.includes(permission))));
  }
}
